let clientShopId: number | undefined;

export const initClientShopId = (shopId: number) => {
  if (typeof window === "undefined" || !shopId || clientShopId !== undefined) {
    return;
  }

  clientShopId = shopId;
};

export const setClientShopId = (shopId: number) => {
  clientShopId = shopId;
};

export const getClientShopId = () => clientShopId;
